import { render, staticRenderFns } from "./empty-intro.vue?vue&type=template&id=44c96dad"
import script from "./empty-intro.vue?vue&type=script&lang=js"
export * from "./empty-intro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports